import Liveness from "./Liveness";
import LoadScriptFilesService from "../LoadScriptFilesService";

export default class LivenessCaf extends Liveness{

    carregarArquivos(id) {
        let loadScript =  new LoadScriptFilesService();
        return loadScript.head_script('https://repo.combateafraude.com/javascript/release/caf-face-liveness/0.13.0/caf-face-liveness_0.13.0.umd.js',id,'high');
    }

    preLoad() {}

    getRouteName() {
        return "LivenessCaf";
    }
}



// WEBPACK FOOTER //
// ./src/services/liveness/LivenessCaf.js